module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "zk-footer"
  }, [_c('div', {
    staticClass: "copyright"
  }, [_c('a', {
    attrs: {
      "href": "https://beian.miit.gov.cn/",
      "target": "_blank"
    }
  }, [_vm._v("粤ICP备20059828号-2")]), _vm._v(" "), _c('img', {
    staticStyle: {
      "float": "left",
      "margin": "0 5px 0 0px"
    },
    attrs: {
      "src": "//www.myzaker.com/images/new/bottom/ga.png"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44010602009154",
      "target": "_blank"
    }
  }, [_vm._v("粤公网安备 44010602009154号")])]), _vm._v(" "), _c('a', {
    staticClass: "email",
    attrs: {
      "href": "mailto:support@myzaker.com"
    }
  }, [_vm._v("举报邮箱：yu998926@163.com")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-323f2d8d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./pc/yiqijian-video/components/Footer/index.vue
// module id = 50
// module chunks = 1 2 3 4 5